import {
  Text,
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  // TableContainer,
  // IconButton,
} from "@chakra-ui/react";

import React from "react";
import Strings from "../config/Strings";

export default function InitializationFailedAlert({
  message,
  onCompleted,
  disclosure,
}) {
  return (
    <AlertDialog
      // size={""}
      size={"lg"}
      isOpen={disclosure.isOpen}
      closeOnOverlayClick={true}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {"Failed to initialize PlexiMail"}
          </AlertDialogHeader>

          <AlertDialogBody fontSize={"sm"}>
            <Text>{message}</Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              mr={4}
              colorScheme={"red"}
              onClick={() => {
                onCompleted(false);
                disclosure.onClose();
              }}
            >
              {"Reset"}
            </Button>

            <Button
              mr={4}
              colorScheme={"green"}
              onClick={() => {
                onCompleted(true);
                disclosure.onClose();
              }}
            >
              {"Retry"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
